import {useState} from "react";
import {Link} from 'react-router-dom'
import {SidebarData} from "./sidebarData";
import openDash from './images/next (1).png'
import closeDash from './images/next (2).png'
import logo from '../../../assets/navbar/Looogo.png'
import './sidebar.css'
const Sidebar = () => {

    const [sidebar, setSidebar] = useState(false)

    const showSidebar = () => {
        setSidebar(p => !p)
    }
    return (
        <div>
            <div className="open_dashboard">
                <img src={openDash} onClick={showSidebar}/>
            </div>
            <nav className={sidebar ? 'sidebar-menu active' : 'sidebar-menu'}>
                <div className="sidebar-menu_logo">
                    <Link to="/"><img src={logo} alt=""/></Link>
                </div>

                <ul className={'sidebar-menu-items'} onClick={showSidebar}>
                    {SidebarData.map((item, index) => {
                        return (
                            <li className={'sidebar-text'} key={index} className={item.cName}>
                                <a href={item.link}>
                                    <span>{item.title}</span>
                                </a>
                            </li>
                        )
                    })}
                </ul>

                <div className="close_dashboard">
                    <img src={closeDash} onClick={showSidebar}/>
                </div>
            </nav>
        </div>
    )
}
export default Sidebar